import Base, { baseInit } from './base';
import { BooleanBase } from './targeting_types/BooleanBase';
import TARGETING_TYPES from '../constant-targeting';

export class TargetableElement extends Base {
  static validations = {
    value(val, te) {
      if (te.targetableElementId === null || te.targetableElementId === undefined) {
        return null; // valid by default
      }

      const tt = TARGETING_TYPES[te.targetableElementId];
      if (!tt) {
        return new Error('Failed to validate targeting value (type not found)');
      }
      const tc = tt.class;
      if (!tc) {
        return new Error('Failed to validate targeting value (class not found)');
      }
      // eslint-disable-next-line new-cap
      if (new tc() instanceof BooleanBase) {
        return null; // always valid
      }
      if (tc.isValid(val)) {
        return null;
      }
      return new Error('Invalid targeting value');
    },
  };

  targetableElementId = null; // Integer
  value = null; // Object{} ? TODO: change once we figure out correct type

  constructor(data) {
    super(data);
    baseInit(this, data);
  }
}
